/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The current state of the debug plan.
 */
export var DebugPlanState;
(function (DebugPlanState) {
    DebugPlanState["IN_PROGRESS"] = "in_progress";
    DebugPlanState["STOPPED"] = "stopped";
})(DebugPlanState || (DebugPlanState = {}));
